#import "../fragments/zoom-meeting-timeline-fragment.graphql"

query GetPotentialMeetings($activityId: ID!, $serviceType: ExternalServiceType!) {
    potentialMeetings(activityId: $activityId, serviceType: $serviceType) {
        ...ZoomMeetingTimelineFragment
    }
}
